<app-help-page mainVideo="notification-destinations"
               [tutorials]="['notification-destinations']"
               [videos]="['notification-destinations']"></app-help-page>
